import { Box, Typography } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import { type ChangeEvent, type FC } from "react"

import { TabletWarehouseFilter } from "../Incoming/components"

import SearchInput from "@/components/SearchInput/SearchInput"
import { type GoodsReceipt, GoodsReceiptStatus } from "@/graphql/codegen/graphql"
import { GoodsReceiptPurchaseOrdersTable, GoodsReceiptsTable } from "@/screens/WarehouseReceiving/components"
import { useGoodsReceiptsTable } from "@/screens/WarehouseReceiving/hooks"

const statuses = [GoodsReceiptStatus.SoftReceived, GoodsReceiptStatus.PreCheckedIn]

export const TabletSoftReceivedGoodsReceiptsContainer: FC = () => {
  const {
    goodsReceipts,
    isGoodsReceiptsFetching,
    pageInfo,
    searchQuery,
    warehouseAreaIds,
    sortingState,
    tableContainerRef,
    handleSearchChange,
    handleFilterChange,
    handleSortingChange,
    handleScroll,
  } = useGoodsReceiptsTable({
    statuses,
    routePath: "/app/tablet/warehouse-receiving",
  })

  const renderExpandedContent = (row: Row<GoodsReceipt>) => (
    <Box className='p-4'>
      <GoodsReceiptPurchaseOrdersTable goodsReceipt={row.original} />
    </Box>
  )

  return (
    <Box className='flex h-full flex-col gap-y-6 p-6'>
      <SearchInput
        placeholder='Search by GR #, Supplier, Tracking or PO Number...'
        defaultValue={searchQuery}
        onChange={(e: ChangeEvent<HTMLInputElement>) => handleSearchChange(e.target.value)}
        className='w-full'
      />

      <Box className='flex items-center justify-between'>
        <Typography variant='h6' className='font-bold text-gray-700'>
          {pageInfo?.total ?? 0} Soft Received
        </Typography>
        <TabletWarehouseFilter
          selectedValue={warehouseAreaIds?.[0] || null}
          onChange={(warehouseId) => handleFilterChange(warehouseId ? [warehouseId] : [])}
        />
      </Box>

      <Box className='flex min-h-0 flex-1 overflow-hidden'>
        <GoodsReceiptsTable
          data={goodsReceipts}
          isLoading={isGoodsReceiptsFetching}
          sortingState={sortingState}
          tableContainerRef={tableContainerRef}
          status={GoodsReceiptStatus.SoftReceived}
          onSortingChange={handleSortingChange}
          onScroll={handleScroll}
          renderExpandedContent={renderExpandedContent}
        />
      </Box>
    </Box>
  )
}
